import React from 'react';
import useTilt from '../hooks/useTilt';

export default function ProductCard({ cat, productCount, navigateTo }) {
  const { tilt, onMouseMove, onMouseLeave } = useTilt();

  return (
    <div className="animate-hidden animate-up" style={{ paddingBottom: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        className="product-card stunner-card"
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        onClick={() => navigateTo('products', cat._id || cat.id)}
        style={{
          transform: `perspective(1500px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) translateY(${tilt.x !== 0 ? -10 : 0}px)`,
          transition: tilt.x === 0 ? 'transform 0.6s ease' : 'none',
          marginBottom: '1.5rem',
          overflow: 'hidden'
        }}
      >
        {/* Shine effect */}
        <div 
          className="card-shine"
          style={{
            background: `radial-gradient(circle at ${tilt.shine.x}% ${tilt.shine.y}%, rgba(255,255,255,0.15) 0%, transparent 80%)`
          }}
        />

        <div className="product-image-container" style={{ height: '100%', padding: '0' }}>
          <span className="pill-overlay" style={{ 
            zIndex: 20,
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <span className="live-pulse" style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#ff4b4b',
              borderRadius: '50%',
              display: 'inline-block',
              marginRight: '6px',
              boxShadow: '0 0 0 0 rgba(255, 75, 75, 0.7)',
              animation: 'pulse-red 2s infinite'
            }}></span>
            {productCount} {productCount === 1 ? 'Product' : 'Products'}
          </span>
          <img
            src={cat.img || 'https://placehold.co/400x500/0a66ff/ffffff?text=Machinery+Image'}
            alt={cat.name}
            className="product-image"
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.src = 'https://placehold.co/400x500/0a66ff/ffffff?text=Image+Not+Found'; 
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transform: `translateZ(60px) scale(${tilt.x !== 0 ? 1.1 : 1})`,
              transition: tilt.x === 0 ? 'transform 0.6s ease' : 'none'
            }}
          />
          
          {/* Hover Overlay Action */}
          <div className="card-hover-overlay">
            <div className="explore-badge">
              EXPLORE PRODUCT <span className="arrow">→</span>
            </div>
          </div>
        </div>
      </div>

      {/* EXTERNAL INFO */}
      <div className="card-external-info" style={{ textAlign: 'center', color: '#fff', width: '100%' }}>
          <h3 className="product-name" style={{ 
            fontSize: cat.name.length > 25 ? '1.4rem' : '1.8rem', 
            fontFamily: 'var(--ff-display)', 
            marginBottom: '0.5rem',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            minHeight: '3.6rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {cat.name}
          </h3>
        <p className="product-ref" style={{ opacity: 0.6, fontSize: '0.8rem', marginBottom: '0' }}>
          N.D. INDUSTRY • PREMIUM SELECTION
        </p>
      </div>
    </div>
  );
}
